import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material";

export const HelperTooltip = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  marginTop: 1,
  color: "#465869",
  cursor: "help",
  marginLeft: "8px",
}));

export const Container = styled("section")(() => ({
  display: "flex",
  flexDirection: "column",
  padding: "16px 12px",
  maxWidth: "312px",
  width: "100%",
  cursor: "help",
  "& > span:nth-child(1)": {
    marginBottom: "4px",
  },
  "& > span:nth-child(2)": {
    marginBottom: "14px",
  },
}));

export const Title = styled("span")(() => ({
  color: "#1D2939",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const Message = styled("span")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: "12px !important",
  },
}));
